const ICS_LINE_BREAK = '\r\n'
const EVENT_TIME_ZONE = 'Europe/London'

class AddToCalendar {
  private readonly buttons: NodeListOf<HTMLButtonElement>

  constructor() {
    this.buttons = document.querySelectorAll<HTMLButtonElement>('.js-event-add-to-calendar')

    if (this.buttons.length === 0) return

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.downloadIcsFile(button)
      })
    })
  }

  private downloadIcsFile(button: HTMLButtonElement): void {
    const start = button.dataset.eventStart
    if (start == null || start === '') return

    const title = button.dataset.eventTitle ?? ''
    const location = button.dataset.eventLocation ?? ''
    const end = button.dataset.eventEnd

    const ics = this.buildIcs({ title, location, start, end })
    const blob = new Blob([ics], { type: 'text/calendar' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = `${this.slugify(title) || 'event'}.ics`
    document.body.appendChild(link)
    link.click()
    link.remove()

    URL.revokeObjectURL(url)
  }

  private buildIcs({
    title,
    location,
    start,
    end,
  }: {
    title: string
    location: string
    start: string
    end?: string
  }): string {
    const dtStart = this.toIcsLocalDate(start)
    // an all-day/undated event still needs an end so calendar apps don't reject the file
    const dtEnd = this.toIcsLocalDate(end ?? start)

    const lines = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Sovereign Housing Association//Survey Site//EN',
      'BEGIN:VEVENT',
      `UID:${crypto.randomUUID()}`,
      `DTSTAMP:${this.toIcsUtcDate(new Date().toISOString())}`,
      `DTSTART;TZID=${EVENT_TIME_ZONE}:${dtStart}`,
      `DTEND;TZID=${EVENT_TIME_ZONE}:${dtEnd}`,
      `SUMMARY:${this.escapeIcsText(title)}`,
    ]

    if (location !== '') {
      lines.push(`LOCATION:${this.escapeIcsText(location)}`)
    }

    lines.push('END:VEVENT', 'END:VCALENDAR')

    return lines.join(ICS_LINE_BREAK)
  }

  private toIcsUtcDate(isoDate: string): string {
    return this.toIcsDate(isoDate)
  }

  private toIcsDate(isoDate: string): string {
    return isoDate.replace(/\.\d+/, '').replace(/[-:]/g, '')
  }

  private toIcsLocalDate(isoDate: string): string {
    return this.toIcsDate(isoDate).replace(/Z|[+-]\d{4}$/, '')
  }

  private escapeIcsText(value: string): string {
    return value.replace(/[\\,;]/g, (match) => `\\${match}`).replace(/\n/g, '\\n')
  }

  private slugify(value: string): string {
    return value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '')
  }
}

export default AddToCalendar

